import { render, staticRenderFns } from "./ConfiguracoesSistema.vue?vue&type=template&id=c49a4654&scoped=true&"
import script from "./ConfiguracoesSistema.vue?vue&type=script&setup=true&lang=js&"
export * from "./ConfiguracoesSistema.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49a4654",
  null
  
)

export default component.exports